<template>
  <div class="list-group list-group-bordered" ref="list">
    <div class="list-group-header d-flex align-items-center"
         :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small }">
        <span :class="{ 'mb-2': extraSmall || small }">{{ researchers.length }} {{
            researchers.length === 1 ? 'Coinvestigador' : 'Coinvestigadores'
                                                       }} agregados</span>
      <div :class="{ 'ml-auto': !extraSmall && !small }">
        <div class="d-inline-block">
          <button type="button"
                  class="btn btn-light" title="Agregar coinvestigadores"
                  data-toggle="modal"
                  data-target="#users-modal"
                  @click="$emit('add-researcher')">
            <i class="fas fa-user-plus mr-2"></i> Agregar coinvestigador
          </button>
        </div>
      </div>
    </div>
    
    <div class="list-group-item"
         :data-id="researcher.id"
         v-for="researcher in researchers"
         :key="researcher.id"
         v-if="researchers && researchers.length">
      
      <div class="list-group-item-figure align-items-start">
        <a href="#" class="user-avatar">
          <img :src="researcher.avatar"
               :alt="researcher.full_name">
        </a>
      </div>
      
      <div class="list-group-item-body">
        <h4 class="list-group-item-title">
          <a href="#">{{ researcher.full_name }}</a>
        </h4>
        <p class="list-group-item-text"> {{ 'Investigador' }} </p>
      </div>
      
      <div class="list-group-item-figure align-items-start">
        <div class="dropdown">
          <button class="btn btn-sm btn-icon btn-light"
                  data-toggle="dropdown"><i
            class="fa fa-fw fa-ellipsis-v"></i></button>
          <div class="dropdown-menu dropdown-menu-right">
            <div class="dropdown-arrow mr-n1"></div>
            
            <button type="button"
                    class="dropdown-item"
                    @click="deleteResearchAssigment(researcher)"
                    ref="btn-remove-researcher">Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'AssignedResearchersList',
    props: {
      researchers: {
        type: Array,
        default: () => ([]),
      },
    },
    data: () => ({
      removing: false,
      listStyles: {},
    }),
    watch: {
      researchers: {
        handler: function () {
          $(this.$refs.list).css('border', 'none')
          $(this.$refs.list).next( ".error" ).remove();
        },
        deep: true
      }
    },
    methods: {
      async deleteResearchAssigment(researcher) {
        this.removing = true
        
        this.researchers.splice(this.researchers.indexOf(researcher), 1)
        
        this.removing = false
      },
    },
    computed: {
      extraSmall() {
        return this.$mq === 'xs'
      },
      small() {
        return this.$mq === 'sm'
      },
    },
  }
</script>
